<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.editApplicableStates_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="select-container">
      <mat-icon [ngClass]="{ focus: select.focused }">place</mat-icon>
      <mat-form-field color="accent">
        <mat-label>{{ data.sysText.headquarters | titlecase }}</mat-label>
        <mat-select #select="matSelect" [formControl]="form.controls.headquartersState" (selectionChange)="onHqSelectChange($event.value)" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
          <mat-option [value]="null"></mat-option>
          @for (state of data.applicableStatesInfo.stateSelectionList; track state) {
            <mat-option [value]="state.stateId">
              <span>{{ state.state }}</span>
            </mat-option>
          }
        </mat-select>
        <!-- mat hint for spacing -->
        <mat-hint></mat-hint>
        <mat-error>{{ form.controls.headquartersState.errors?.msError }}</mat-error>
        @if (form.controls.headquartersState.errors?.required) {
          <mat-error>{{ data.sysText.headquarters | titlecase }} {{data.sysText.required}}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="select-container">
      <mat-icon [ngClass]="{ focus: select.focused }">add_location</mat-icon>
      <mat-form-field color="accent">
        <mat-label>{{ data.sysText.additionalStates | titlecase }}</mat-label>
        <mat-select #select="matSelect" [formControl]="form.controls.additionalStates" multiple disableOptionCentering panelClass="dropDownSelectMultiple" panelWidth="fit-content">
          <mat-select-trigger>
            @if (additionalStates.value?.length >= 1) {
              <span>
                @for (stateId of additionalStates.value; track stateId; let i = $index) {
                  <span>
                    {{getStateAbbr(stateId)}}@if (i !== additionalStates.value?.length - 1) {
                    <span>, </span>
                  }
                </span>
              }
            </span>
          }
        </mat-select-trigger>
        @for (state of selectionOptions; track state) {
          <mat-option [value]="state.stateId">
            <span>{{ state.state }}</span>
          </mat-option>
        }
      </mat-select>
      <mat-error>{{ additionalStates.errors?.msError }}</mat-error>
      @if (additionalStates.errors?.required) {
        <mat-error>{{ data.sysText.additionalStates | titlecase }} {{data.sysText.required}}</mat-error>
      }
    </mat-form-field>
  </div>
</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

